import type { StateCreator } from 'zustand';
import type { LeaderboardEntry, HeatmapData, TimeseriesPoint } from '../types';
import { strategyDashboardApi } from '../services/strategyDashboardApi';

export interface StrategyDashboardSlice {
  leaderboard: LeaderboardEntry[];
  heatmapData: HeatmapData[];
  timeseriesData: Record<number, TimeseriesPoint[]>;
  dashboardLoading: boolean;

  fetchLeaderboard: () => Promise<void>;
  fetchHeatmap: () => Promise<void>;
  fetchTimeseries: (strategyId?: number, days?: number) => Promise<void>;
  fetchDashboard: () => Promise<void>;
}

export const createStrategyDashboardSlice: StateCreator<StrategyDashboardSlice> = (set) => ({
  leaderboard: [],
  heatmapData: [],
  timeseriesData: {},
  dashboardLoading: false,

  fetchLeaderboard: async () => {
    const leaderboard = await strategyDashboardApi.leaderboard();
    set({ leaderboard });
  },

  fetchHeatmap: async () => {
    const heatmapData = await strategyDashboardApi.heatmap();
    set({ heatmapData });
  },

  fetchTimeseries: async (strategyId, days = 30) => {
    const data = await strategyDashboardApi.timeseries(strategyId, days);
    if (strategyId !== undefined) {
      set((s) => ({
        timeseriesData: { ...s.timeseriesData, [strategyId]: data as TimeseriesPoint[] },
      }));
    } else {
      set({ timeseriesData: data as Record<number, TimeseriesPoint[]> });
    }
  },

  fetchDashboard: async () => {
    set({ dashboardLoading: true });
    try {
      await Promise.all([
        strategyDashboardApi.leaderboard().then((leaderboard) => set({ leaderboard })),
        strategyDashboardApi.heatmap().then((heatmapData) => set({ heatmapData })),
        strategyDashboardApi.timeseries().then((data) =>
          set({ timeseriesData: data as Record<number, TimeseriesPoint[]> })
        ),
      ]);
    } finally {
      set({ dashboardLoading: false });
    }
  },
});
